import { inject } from '@angular/core';
import {
  callApiMethod,
  setError,
  setLoaded,
  setLoading,
  withExport,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { AccessPoint } from '../models/access-point.model';
import { AccessPointsService } from '../services/access-points.service';
import { withMapImage } from './map-image-feature';

export const AccessPointsStore = signalStore(
  { protectedState: false },
  withResourceState(AccessPointsService, {
    query: {
      initial: {
        sort: ['city', 'district', 'street', 'houseNumber', 'houseNumberLocal'],
      },
    },
  }),
  withExport(AccessPointsService),
  withState<{ odbOptions: { label: string; value: string }[] }>({
    odbOptions: [],
  }),
  withMapImage(),
  withMethods((store, service = inject(AccessPointsService)) => ({
    updateTechnical: (id: string, data: Partial<AccessPoint>) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.udpateTechnical(id, data), {
        next: () => patchState(store, setLoaded()),
        error: (err) => patchState(store, setError(err)),
        finalize: () => patchState(store, setLoaded()),
      });
    },
    copy: (id: string) => {
      patchState(store, { model: null }, setLoading());
      return callApiMethod(() => service.copy(id), {
        next: (ap) => patchState(store, { model: ap }, setLoaded()),
        error: (err) => patchState(store, setError(err)),
      });
    },
    loadOdbOptions: (id: string) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.getOdbsByApId(id), {
        next: (data) => {
          patchState(
            store,
            {
              odbOptions: data.map((odb) => ({
                label: odb.fttxId,
                value: odb.fttxId,
              })),
            },
            setLoaded(),
          );
        },
        error: (err) => patchState(store, setError(err)),
      });
    },
    refreshFromSsd: (id: string) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.refreshFromSsd(id), {
        next: () => {
          patchState(store, setLoaded());
        },
        error: (err) => patchState(store, setError(err)),
      });
    },
  })),
);
